exports.install = function (Vue, options) {
	//获取项目列表
	Vue.prototype.getproject = function(value={})
	{
		return this.axiosget("/api/project/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('project',response.data.data.list);
			}
		})
	};
	//添加项目
	Vue.prototype.addproject = function(value)
	{
		return this.axiospost("/api/project/add",value)
		.then((response)=>{
			return response;
		});
	};
	//删除项目
	Vue.prototype.delproject = function(value)
	{
		this.axiospost("/api/project/delete",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getproject();
			}
			return response;
		});
	};
}